module.exports = __webpack_public_path__ + "static/img/why-1-1.fc82277.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/why-1-1.png
// module id = OjPm
// module chunks = 1